import { useRedirect, useNotify, useTranslate } from "react-admin";
import Form from "./Form";
import { CgEditProps, CgEdit } from "../../../components/common";
import { Resources } from "../../resource";

const EditPopup = (props: CgEditProps) => {
  const redirect = useRedirect();
  const notify = useNotify();
  const t = useTranslate();

  const onSuccess = () => {
    const currentUrl = window.location.href;
    const origin = window.location.origin;
    const redirectValue = currentUrl.replace(origin, '');

    notify(t('module.prediction.system-configs.validate.updateSuccess'), { type: 'success', autoHideDuration: 1000 });

    if (props.onClose) {
      props.onClose();
    }
    if (props.resource) {
      redirect(redirectValue, props.resource);
    }
  };

  const onError = (error: any) => {
    const errorCode = error?.body?.code;
    const notifyError = (msg: string) => {
      notify(msg, { type: 'error' });
    };

    switch (errorCode) {
      case 'PREDICTION_CONFIG_NOT_FOUND':
        notifyError(t('module.prediction.system-configs.validate.predictionConfigNotFound'));
        break;
      case 'PREDICTION_CONFIG_ID_REQUIRED':
        notifyError(t('module.prediction.system-configs.validate.predictionConfigIdRequired'));
        break;
      case 'INTERNAL_SERVER_ERROR':
        notifyError(error?.message || t('module.prediction.system-configs.unknownErrorUpdate'));
        break;
      default:
        notifyError(t('module.prediction.system-configs.unknownErrorUpdate'));
        break;
    }
  };
  return (
    <CgEdit
      {...props}
      title="module.prediction.system-configs.edit"
      resource={Resources.predictionConfigs}
      onClose={props.onClose}
      mutationMode="pessimistic"
      mutationOptions={{ onSuccess, onError }}
    >
      <Form isCreate={false} />
    </CgEdit>
  );
};

export default EditPopup;